module.exports = {
  message: {
    login: "Login",
    Username: "Username",
    zh: "Chinese",
    en: "English",
    out_name: "WIN365",
    out_app_kind: "ความบันเทิง",
    first: "คาสิโนสด อันดับแรก",
    k_score: "K ให้คะแนน",
    install: "ติดตั้ง",
    install_free: "ติดตั้งฟรี",
    android_no_support: "ไม่สามารถใช้ Android",
    start_download: "เริ่มดาวน์โหลด",
    down_fail: "ดาวน์โหลดล้มเหลว",
    try_again: "ลองอีกครั้ง",
    installing: "กำลังติดตั้ง",
    install_introduce: "คู่มือการติดตั้ง",
    appal_video_guild: "วิดีโอสอนการติดตั้ง Apple APP",
    over: "เสร็จสิ้น",
    open_in_itune: "โปรดทำตามคำแนะนำเพื่อเปิดลิงก์ใน iTunes เพื่อติดตั้ง",
    out_guide_link: "",
    intro: "บทนำ",
    out_intro:
      "สำนักงานใหญ่ตั้งอยู่ในฟิลิปปินส์พร้อมใบอนุญาตเล่นเกม PAGCOR ที่ถูกกฎหมายดำเนินธุรกิจสื่อบันเทิงกีฬาและคาสิโนหลายแบรนด์และขอบเขตธุรกิจครอบคลุมทั่วโลก กลุ่มของเรามีผู้จัดการที่มีประสบการณ์มากกว่า 10 ปีในอุตสาหกรรมเกมและพนักงานบริการระดับมืออาชีพมากกว่า 2,000 คน พวกเขาส่งเสริมความร่วมมือเชิงกลยุทธ์อย่างจริงจังในการแข่งขันกีฬาหนังสือตรวจสอบและคัดกรองเกมทุกประเภทอย่างเข้มงวดเพื่อให้แน่ใจว่ามีความยุติธรรม เกมและผลิตภัณฑ์ทั้งหมดของกลุ่มผ่านการทดสอบและการตรวจสอบหลายครั้งเพื่อให้แน่ใจว่าอัตราต่อรองและการตัดสินถูกต้องและมอบประสบการณ์การเล่นเกมที่ยุติธรรมและมีคุณภาพสูงให้กับผู้ใช้",
    score_and_post: "การให้คะแนนและบทวิจารณ์",
    fullscore: "จาก 5",
    new_fun: "ฟังก์ชั่นใหม่",
    out_new_feature: "",
    info: "ข้อมูล",
    out_distributor: "Win365",
    distributor: "พันธมิตร",
    size: "ขนาด",
    kind: "ประเภท",
    need_ios_compatible: "ต้องใช้ IOS 9.0 ขึ้นไปเข้ากันได้กับ iphone",
    compatible: "ความเข้ากันได้",
    out_langs: "ภาษาจีนตัวย่อ,ภาษาอังกฤษ,ญี่ปุ่น,เวียดนาม,ไทย",
    lang: "ภาษา",
    age_limit: "ระดับอายุ",
    age: "อายุ",
    out_copyright: "",
    copyright: "ลิขสิทธิ์",
    out_app_price: "ฟรี",
    price: "ราคา",
    policy_privay: "นโยบายความเป็นส่วนตัว",
    randomCode: "ระบุเอกลักษณ์",
    under18: "อายุมากกว่า 18 ปี",
    disclaimer: "ข้อจำกัดความรับผิดชอบ",
    disclaimer_detail:
      "เว็บไซต์นี้ให้บริการโฮสติ้งการดาวน์โหลดและติดตั้งแอปแก่นักพัฒนาเท่านั้น ",
    step1: "ขั้นตอนที่ 1",
    click_coner: "คลิกที่มุมขวาบน",
    button: "ปุ่ม",
    step2: "ขั้นตอนที่ 2",
    open_IE: "เข้าและเปิดในเบราว์เซอร์ซาฟารี",
    click_copy: 'คลิกลิงก์ "คัดลอก"',
    outof_limit:
      "จำนวนการดาวน์โหลดในวันนี้ถึงจำกัดแล้ว โปรดลองอีกครั้งในวันพรุ่งนี้!",
    back_detail: "โปรดกลับไปที่เดสก์ท็อปเพื่อดูรายละเอียด",
    desc: "ไฟล์คำอธิบาย",
    desc_why_install: "1. ไฟล์คำอธิบายคืออะไรและทำไมต้องติดตั้ง?",
    desc_reson:
      "ไฟล์คำอธิบายได้รับการรับรองโดย Apple และใช้บันทึกอุปกรณ์ของผู้ใช้ โปรดใช้ด้วยความมั่นใจ การติดตั้งไฟล์คำอธิบายคือการลงทะเบียนอุปกรณ์ของคุณกับไลบรารีผู้ใช้ Apple เป็นข้อกำหนดเบื้องต้นสำหรับการติดตั้งตัวช่วยติดตั้ง Apple APP",
    desc_explain_title:
      "2. หากติดค้างในหน้าการตั้งค่าระหว่างการติดตั้งจะแก้อย่างไร?",
    desc_explain_desc:
      "การติดขัดเป็นข้อบกพร่องของระบบ iOS วิธีแก้ไข: กลับไปที่เดสก์ท็อปเลื่อนขึ้น - ปิดหน้าการตั้งค่าติดตั้งใหม่",
    desc_why_password: "3. ทำไมต้องใส่รหัสผ่านเมื่อติดตั้งไฟล์คำอธิบาย? ",
    desc_psw_reson:
      'รหัสผ่านอะไรเพื่อยืนยันว่าเจ้าของอุปกรณ์กำลังดำเนินการอยู่คุณต้องป้อน "Unlock Passcode" เมื่อติดตั้งไฟล์คำอธิบาย',
    desc_know: "รับทราบแล้ว",
    guild_title_1: "Geliştirici modu nasıl etkinleştirilir?",
    guild_title: "ไฟล์คำอธิบายคืออะไร?",
    guild: "คู่มือการติดตั้ง",
    guild_step1: "ขั้นตอนที่ 1 อนุญาตให้เปิดไฟล์คำอธิบายการกำหนดค่า",
    guild_step2: 'ขั้นตอนที่ 2 คลิกปุ่ม "ติดตั้ง" ที่มุมขวาบน',
    guild_step3: "ขั้นตอนที่ 3 ป้อนรหัสผ่านปลดล็อคเมื่อเปิดเครื่อง",
    guild_step4: 'ขั้นตอนที่ 4 คลิกปุ่ม "ติดตั้ง" ด้านล่าง',
    error1: "เครือข่ายผิดปกติโปรดติดต่อฝ่ายบริการลูกค้า\n",
    ageleft: "อายุมากกว่า ",
    ageright: " ปี",
    versionleft: "ต้องใช้ IOS ",
    versionright: " ขึ้นไปเข้ากันได้กับ iphone",
    to_main_site: "เข้าสู่ระบบเว็บ",
    release_time: "วันที่วางจำหน่าย",
    previous_version: "รุ่นก่อนหน้า",
    version_info: "ข้อมูลเวอร์ชัน",
    ios16Tip1: "สำหรับ ios16 ขึ้นไป โปรดเปิดใช้งานโหมดผู้พัฒนาก่อน",
    ios16Tip2:
      "“การตั้งค่า -> ความเป็นส่วนตัวและความปลอดภัย -> โหมดผู้พัฒนา -> เปิดใช้งาน”"
  }
};



// WEBPACK FOOTER //
// ./src/common/lang/tl.js